// src/auditTypes.ts
export type KeyQuestion = 'safe' | 'effective' | 'caring' | 'responsive' | 'wellled';
export type Frequency = 'daily' | 'weekly' | 'monthly' | 'quarterly' | 'annual';
export type AnswerValue = 'yes' | 'partial' | 'no' | 'na';
export type Priority = 'high' | 'medium' | 'low';

export interface AuditQuestion {
  id: string;
  text: string;
  guidance: string;        // what CQC expects / how to evidence
  keyQuestion: KeyQuestion;
  regulation?: string;     // e.g. "Reg 12"
  critical?: boolean;      // critical failure => auto high priority
}

export interface AuditTemplate {
  id: string;
  name: string;
  frequency: Frequency;
  description: string;
  questions: AuditQuestion[];
}

export interface AnswerRecord { questionId: string; value: AnswerValue; note: string; }

export interface AuditRecord {
  id: string;
  templateId: string;
  templateName: string;
  frequency: Frequency;
  dateISO: string;
  completedBy: string;
  answers: Record<string, AnswerRecord>;
  score: number | null;
  status: 'in-progress' | 'completed';
}

export interface ActionPlan {
  id: string;
  auditRecordId: string;
  auditName: string;
  questionId: string;
  issue: string;
  action: string;
  owner: string;
  priority: Priority;
  raisedDate: string;
  dueDate: string;
  status: 'open' | 'in-progress' | 'closed';
  closedDate?: string;
  closureEvidence?: string;
  keyQuestion: KeyQuestion;
}

export const KEY_QUESTION_META: Record<KeyQuestion, { label: string; color: string }> = {
  safe:       { label: 'Safe',       color: '#B3261E' },
  effective:  { label: 'Effective',  color: '#1D6FB8' },
  caring:     { label: 'Caring',     color: '#C77800' },
  responsive: { label: 'Responsive', color: '#6B4FA3' },
  wellled:    { label: 'Well-led',   color: '#123B36' },
};